@if ((errorCode$$ | async) === 404) {
  <div class="business">
    <div class="business-icon">
      <mat-icon>business</mat-icon>
    </div>
    <div class="business-details">
      <div class="business-error">
        {{ 'PAYMENT_PAGE.BUSINESS_NOT_FOUND' | translate }}
      </div>
    </div>
  </div>
} @else {
  <a [routerLink]="['/businesses/accounts', businessId, 'details']">
    <div class="business enabled">
      <div class="business-icon">
        <mat-icon>business</mat-icon>
      </div>
      @if (loading$$ | async) {
        <div class="business-details">
          <div class="business-title stencil-shimmer loading"></div>
          <div class="business-address stencil-shimmer loading"></div>
        </div>
      }
      @if (business$ | async; as business) {
        <div class="business-details">
          <div class="business-title">{{ business.name }}</div>
          <div class="business-address">{{ business.address }}</div>
        </div>
      }
      @if ((errorCode$$ | async) !== null) {
        <div class="business-details">
          <div class="business-error">
            {{ 'PAYMENT_PAGE.GENERAL_ERROR' | translate }}
          </div>
        </div>
      }
      <div class="spacer"></div>
      <div class="arrow">
        <mat-icon>navigate_next</mat-icon>
      </div>
    </div>
  </a>
}
